import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import SessionConfig from "../../config/session_config"
import { useTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import "./uploadFiles.scss"
import service from "../../api/monitor.service"
import AsyncSelect from "react-select/async"
import DataTable from "react-data-table-component"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import UploadFileForm from "./UploadFileForm"
import UploadFileModalMessage from "./UploadFileModalMessage"
import dictionary from "../../config/dictionary"
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Form,
  Label,
  FormGroup,
  Button,
  Container,
  Badge,
} from "reactstrap"
import showToast from "../../components/Common/viewNotification"
import {
  cleanView,
  deleteFiles,
  downloadFile,
  getFilesByArea,
  initLoadUserData,
} from "../../store/actions"
import { is_empty } from "../../config/validate"
import ContentTypeMapper from "../../components/utils/contentTypeMapper"

const UploadFiles = () => {
  const ref = useRef()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [supplier, setSupplier] = useState({
    value: 0,
    label: t("monitor:supplierFind"),
  })
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [columns, setColumns] = useState([])
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [currentRow, setCurrentRow] = useState(null)
  const [showModalForm, setShowModalForm] = useState(false)
  const contentTypeMapper = new ContentTypeMapper()
  const [showMsg, setShowMsg] = useState(false)
  // header title
    document.title = t("filesUpload:titleConf") + " | " + t("global:title")
  //#region  store
  const {
    response,
    loading,
    error,
    loadingSupplier,
    currentUser,
    fileList = [],
    responseDownloadFile,
    responseDeleteUpload,
  } = useSelector(state => ({
    fileList: state.fileUpload.fileList,
    loading: state.fileUpload.loading,
    response: state.fileUpload.response,
    error: state.fileUpload.error,
    currentUser: state.Dashboard.user,
    responseDownloadFile: state.fileUpload.responseDownloadFile,
    responseDeleteUpload: state.fileUpload.responseDownloadFile,
  }))

  useEffect(() => {
    document.getElementById("body").className = "fondo4"
    document.title = t("filesUpload:titleConf") + " | " + t("global:title")
    initColumns()
    loadUser()
  }, [])
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])
  useEffect(() => {
    if (
      currentUser &&
      auth.id.role.transactionRol != process.env.REACT_APP_ROL_SUPERVISOR_CODE
    )
      loadFiles()
  }, [currentUser])
  
  useEffect(() => {
    loadFiles()
  }, [page, size])

  useEffect(() => {
    if (response) {
      showToast(t("global:msgSuccessSaveList"), "success", t("global:config"))
      cleanStates()
    }
    if (responseDownloadFile != null) {
      downloadFiles(responseDownloadFile)
      cleanStates()
    }
  }, [responseDownloadFile])
  const cleanStates = async () => {
    await dispatch(cleanView())
  }
  const loadUser = async () => {
    if (auth) {
      const request = {
        username: auth.id.user.username,
      }
      await dispatch(initLoadUserData(request))
    }
  }
  const downloadFiles = responseDownloadFile => {
    if (!responseDownloadFile?.data) return

    try {
      const fileName = responseDownloadFile.data.data.name
      const extension = fileName.split(".").pop()
      const contentType = extension
        ? contentTypeMapper.getContentType(extension)
        : "application/octet-stream"

      const base64Data = responseDownloadFile.data.data.data.replace(
        /^data:.*;base64,/,
        ""
      )

      const byteCharacters = atob(base64Data)
      const byteArray = new Uint8Array(byteCharacters.length)

      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i)
      }

      const blob = new Blob([byteArray], { type: contentType })

      const link = document.createElement("a")
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      showToast(
        t("filesUpload:msgDownloadSuccess"),
        "success",
        t("filesUpload:titleDownload")
      )
    } catch (error) {
      showToast(t(error), "error", t("filesUpload:msgDownloadFail"))
      console.error("Error al procesar el archivo de descarga", error)
    }
  }
  const loadFiles = async () => {
    let body = {
      length: size,
      page: page,
      user: currentUser,
      area: supplier?.area?.code,
      supplier: supplier.code
    }
    await dispatch(getFilesByArea(body))
  }

  const search = async () => {
    loadFiles()
  }

  const initColumns = () => {
    let col = [
      {
        name: t("filesUpload:titleNameFile"),
        sortable: false,
        wrap: true,
        grow: 4,
        cell: row => (
          <div>
            <div className=" "><Badge
                color={
                  row.typeCode === dictionary.configApp.type.required
                    ? "danger"
                    : "primary"
                }
              >
                {row.typeFileName}
              </Badge> {row.fileName}</div>
            <div>
              <span className="text-muted">{row.updateFrequency}</span>
            </div>
          </div>
        ),
      },
      {
        name: t("files:titleAreaSupplier"),
        sortable: false,
        wrap: true,
        grow: 2,
        cell: row =>  <div>
          {row.supplier?.name}
          <h6 className="text-muted">{row.areaName}</h6></div>,
      },
      {
        name: t("filesUpload:lblMaterial"),
        sortable: false,
        wrap: true,
        grow: 2,
        cell: row => <div className=" text-lowercase">{row?.material?.name}
                <div><Badge>{row?.material?.codeSap}</Badge></div></div>,
      },
      {
        name: t("filesUpload:titleStatusFile"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => <h6 className="text-muted ">{row.statusUpload}</h6>,
      },
      {
        name: "Acciones",
        grow: 2,
        cell: row => (
          <>
            <div className="d-flex flex-row align-items-center gap-2">
              {row.statusUpload === "SI" ? (
                <Button
                  color="danger"
                  size="sm"
                  onClick={() => viewUploadForm(row, true)}
                >
                  <i className="fa fa-trash me-1"></i> Borrar archivo
                </Button>
              ) : (
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => viewUploadForm(row, true)}
                >
                  <i className="fa fa-upload me-1"></i> Subir archivo
                </Button>
              )}

              <Button
                disabled={row.statusUpload == "NO"}
                color="info"
                size="sm"
                outline
                onClick={e => handleDownloadFile(e, row)}
              >
                Descargar
              </Button>
            </div>
          </>
        ),
      },
    ]
    setColumns(col)
  }
  const handleDownloadFile = async (event, row) => {
    event.preventDefault()
    await dispatch(downloadFile(row.path))
  }
  const handlePerRowsChange = async (perPage, page) => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
    await setSize(perPage)
  }
  const handlePageChange = async page => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
  }

  const loadSuppliers = filter => {
    if (auth) {
      const json = {
        username: auth?.id?.user?.username,
        length: 30,
        filter,
        societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      }
      return service.getSupplier(json)
    }
  }

  const loadingOptionSupplier = async (filter, callback) => {
    if (filter.length >= 3) {
      const data = await loadSuppliers(filter)
      const s = data?.data?.map(item => {
        return {
          ...item,
          value: item.code,
          label: item.name + " | " + item.code,
        }
      })
      callback(s)
    }
  }

  const onChangeSupplier = (value, action) => {
    setSupplier(value)
  }

  const viewUploadForm = (row, valD) => {
    setCurrentRow(row)
    if (row?.statusUpload == "SI") {
      toggleMessage(true)
    } else setShowModalForm(valD)
  }
  const closeModal = async () => {
    setShowModalForm(false)
  }
  const toggleMessage = val => {
    setShowMsg(val)
  }
  const deleteFileList = async () => {
    const fileName = currentRow.path.split("/").pop()
    const pathOnly = currentRow.path.substring(
      0,
      currentRow.path.lastIndexOf("/")
    )
    let body = {
      path: [{ name: fileName, data: pathOnly + "/" }],
      fileUpload: {
        id: currentRow.fileId,
      },
    }
    await dispatch(deleteFiles(body))
  }

  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("filesUpload:titleConf")}
          />
          <div>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    {auth.id.role.transactionRol !==
                      process.env.REACT_APP_ROL_PROVIDER_CODE && (
                        <>
                          <CardTitle className="h5 mb-4 text-primary">
                            {t("files:filterTitle")}
                          </CardTitle>
                          <Form className="row gy-2 gx-3 align-items-center justify-content-start">
                            <div className="col-12 col-lg-6">
                              <FormGroup className="mb-4">
                                <Label>
                                  {t("filesUpload:lblSupplier")}{" "}
                                  <span className="text-danger">(*)</span>
                                </Label>
                                <div className="d-flex flex-row align-items-center gap-2">
                                  <div className="flex-grow-1">
                                    <AsyncSelect
                                      loadOptions={loadingOptionSupplier}
                                      maxMenuHeight={150}
                                      cacheOptions
                                      className="small-font text-uppercase"
                                      isDisabled={loading}
                                      placeholder={t("monitor:supplierFind")}
                                      name="supplier"
                                      isClearable
                                      isLoading={loadingSupplier}
                                      onChange={(value, action) => {
                                        onChangeSupplier(value, action)
                                      }}
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-primary save-user"
                                    disabled={loading}
                                    onClick={search}
                                  >
                                    <i className="fas fa-search me-1" />
                                  </button>
                                </div>
                              </FormGroup>
                            </div>
                          </Form>
                        </>
                      )}
                    <DataTable
                      title={
                        <label className="text-primary text-uppercase font-size-16">
                          <i className="fa fa-list font-size-18  me-1 " />
                          {t("filesUpload:titleList")}
                        </label>
                      }
                      columns={columns}
                      data={fileList?.fileUploadList}
                      dense
                      fixedHeaderScrollHeight="600px"
                      pagination
                      paginationServer
                      paginationTotalRows={fileList?.size}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      progressPending={loading}
                      progressComponent={<LinearIndeterminate />}
                      noDataComponent={t("tableOptions:noDataComponent")}
                      paginationComponentOptions={{
                        rowsPerPageText: t("tableOptions:rowsPerPageText"),
                        rangeSeparatorText: t(
                          "tableOptions:rangeSeparatorText"
                        ),
                        selectAllRowsItem: true,
                        selectAllRowsItemText: t(
                          "tableOptions:selectAllRowsItemText"
                        ),
                      }}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {showModalForm ? (
              <UploadFileForm
                modalOpen={showModalForm}
                viewUploadForm={viewUploadForm}
                currentRow={currentRow}
                currentUser={currentUser}
                supplierSelected={supplier}
                loadFiles={loadFiles}
                closeModal={closeModal}
                showMod={setShowModalForm}
              />
            ) : (
              <></>
            )}
            {showMsg ? (
              <UploadFileModalMessage
                modalOpen={showMsg}
                toggleModalMsg={toggleMessage}
                changeStatus={deleteFileList}
                title={t("filesUpload:titleModalDelete")}
                msg={t("filesUpload:msgModalDelete")}
                loadFiles={loadFiles}
                currentRow={currentRow}
              />
            ) : (
              <></>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default UploadFiles
